export const BusinessTier = {
  Tier0: 0,
  BasicTier: 1,
  StandardTier: 2,
  PremiumTier: 3
};
export const getBusinessTier = (merchant) => {
  if (!merchant?.businesses?.length) {
    return BusinessTier.Tier0;
  }
  if (
    merchant.businesses.length === 1 &&
    merchant.businesses[0]?.businessTier === 0 &&
    merchant.businesses[0]?.businessVerificationStatus === 3
  ) {
    return BusinessTier.Tier0;
  }
  return BusinessTier.BasicTier;
};
